import React, { useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

const WebsiteContent: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/website') {
      navigate('/website/banners', { replace: true });
    }
  }, [location.pathname, navigate]);

  const tabs = [
    { name: 'Banners', href: '/website/banners', current: location.pathname === '/website/banners' },
    { name: 'Featured Designers', href: '/website/featured-designers', current: location.pathname === '/website/featured-designers' },
    { name: 'Homepage Dresses', href: '/website/homepage-dresses', current: location.pathname === '/website/homepage-dresses' },
    { name: 'Information Page', href: '/website/page-content', current: location.pathname === '/website/page-content' },
    { name: 'Newsletter', href: '/website/newsletter', current: location.pathname === '/website/newsletter' },
  ];

  return (
    <div>
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900">Website Content</h2>
        <p className="text-sm text-gray-500">Manage what customers see on your website</p>
      </div>
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <Link
              key={tab.name}
              to={tab.href}
              className={`
                ${tab.current
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              `}
            >
              {tab.name}
            </Link>
          ))}
        </nav>
      </div>
      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
};

export default WebsiteContent;
